var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.path == `/provider/bundles`)?_c('Bundles'):_vm._e(),(_vm.path == `/provider/bundles/builder`)?_c('Builder'):_vm._e(),(_vm.path == `/provider/bundles/bundle`)?_c('SingleBundle'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }